import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserPermissionsService } from '../shared/services/user-permissions.service';
import { map, filter } from 'rxjs/operators';
import { MessagesService } from '../shared/services/messages.service';

export const permissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const userPerms = inject(UserPermissionsService);
  const messages = inject(MessagesService);
  // Get required permission from route data
  const requiredPermission = route.data['permission'] as string;

  return userPerms.permissions$.pipe(
    // Wait until some permissions exist (avoid empty object issue)
    filter(perms => Object.keys(perms).length > 0),
    map(perms => {

        const isManageStudentsRoute = route.routeConfig?.path === 'manage-students';

        if (isManageStudentsRoute) {
          if (perms['all'] || perms['course.manage'] || perms[requiredPermission]) {
            return true;
          }
          return router.parseUrl('/courses');
        }


        if(route.routeConfig?.path === 'general') {
          if(!perms['course.manage'] ){
            return true;
          }
        }

      if (perms['all'] || perms[requiredPermission]) {
        return true;
      }
      // redirect to the courses screen
      messages.error('You don’t have permission to access this page.');
      return router.parseUrl('/courses');
    })
  );
};